import React from "react";
import { Card, CardBody, Row, Col, Badge } from "reactstrap";
import NumberFormat from "react-number-format";

const LeaseEndOptions = ({
	account,
	lease,
	leaseEndData,
	updateLeaseEndData,
}) => {
	const handleOptionSelect = (option) => {
		updateLeaseEndData({ selectedOption: option });
	};

	const remainingPayments = account.amtFinanced - account.principle;
	const residualValue = lease.residualValue || 0;
	const dispositionFee = lease.disposition || 0;
	const isDispositionAtLeaseEnd = lease.capDispositionFee === 0;

	const options = [
		{
			id: "buyout",
			title: "Purchase Vehicle (Buyout)",
			description:
				"Pay the residual value and any outstanding amounts to own the vehicle",
			icon: "🚗",
			details: [
				`Residual Value: $${residualValue.toFixed(2)}`,
				`Remaining Payments: $${remainingPayments.toFixed(2)}`,
				`Estimated Total: $${leaseEndData.buyoutAmount.toFixed(2)}`,
				dispositionFee > 0 && `Note: Disposition fee ($${dispositionFee.toFixed(2)}) is NOT charged on buyout`,
			].filter(Boolean),
			recommended: remainingPayments < residualValue * 0.2,
		},
		{
			id: "return",
			title: "Return Vehicle (Normal Completion)",
			description:
				"Return the vehicle after making all lease payments. Vehicle returns to inventory.",
			icon: "↩️",
			details: [
				`All lease payments must be current`,
				`Vehicle will be inspected for excess wear`,
				`May incur mileage and damage fees`,
				isDispositionAtLeaseEnd && dispositionFee > 0 && `Disposition Fee: $${dispositionFee.toFixed(2)} will be charged`,
			].filter(Boolean),
			recommended: false,
		},
		{
			id: "early_termination",
			title: "Early Termination",
			description:
				"End lease early with applicable termination fees. Vehicle returns to inventory.",
			icon: "⚠️",
			details: [
				`Early termination fees apply`,
				`Remaining payments: $${remainingPayments.toFixed(2)}`,
				`Additional fees may apply`,
			],
			recommended: false,
		},
	];

	return (
		<div>
			<h4 className="mb-4">Select Lease End Option</h4>
			{/* <p className="text-muted mb-4">
				Choose how you would like to complete this lease.
			</p> */}

			<Row>
				{options.map((option) => (
					<Col md="12" key={option.id}>
						<Card
							className={`option-card ${
								leaseEndData.selectedOption === option.id ? "selected" : ""
							}`}
							onClick={() => handleOptionSelect(option.id)}
						>
							<CardBody>
								<Row>
									{/* <Col md="2" className="text-center">
										<div className="option-icon">{option.icon}</div>
									</Col> */}
									<Col md="10">
										<div className="d-flex justify-content-between align-items-start mb-2">
											<h5>{option.title}</h5>
											{option.recommended && (
												<Badge color="success">Recommended</Badge>
											)}
										</div>
										<p className="text-muted">{option.description}</p>
										{/* <ul className="mb-0">
											{option.details.map((detail, idx) => (
												<li key={idx}>{detail}</li>
											))}
										</ul> */}
									</Col>
								</Row>
							</CardBody>
						</Card>
					</Col>
				))}
			</Row>

			{/* Account Status Summary */}
			{/* <Card className="mt-4 fee-summary-card">
				<CardBody>
					<h5>Current Account Status</h5>
					<div className="fee-row">
						<span>Lease Account Number:</span>
						<strong>{account.accountNumber}</strong>
					</div>
					<div className="fee-row">
						<span>Residual Value:</span>
						<strong>
							<NumberFormat
								value={residualValue}
								displayType="text"
								thousandSeparator
								prefix="$"
								decimalScale={2}
								fixedDecimalScale
							/>
						</strong>
					</div>
					<div className="fee-row">
						<span>Remaining Principal:</span>
						<strong>
							<NumberFormat
								value={remainingPayments}
								displayType="text"
								thousandSeparator
								prefix="$"
								decimalScale={2}
								fixedDecimalScale
							/>
						</strong>
					</div>
					<div className="fee-row">
						<span>Days Late:</span>
						<strong className={account.daysLate > 0 ? "text-danger" : ""}>
							{account.daysLate || 0} days
						</strong>
					</div>
					{account.pastDueAmt > 0 && (
						<div className="fee-row">
							<span>Past Due Amount:</span>
							<strong className="text-danger">
								<NumberFormat
									value={account.pastDueAmt}
									displayType="text"
									thousandSeparator
									prefix="$"
									decimalScale={2}
									fixedDecimalScale
								/>
							</strong>
						</div>
					)}
				</CardBody>
			</Card> */}
		</div>
	);
};

export default LeaseEndOptions;
